<template>
	<ul v-if="bundle">
		<li>{{ $t('bundle.packageNr') }} {{ bundle.strBundleNo }}</li>
		<li>{{ $t('bundle.length') }} {{ bundle.intLength }} {{ $t('unit.cm') }}</li>
		<li>{{ $t('bundle.width') }} {{ bundle.intWidth }} {{ $t('unit.cm') }}</li>
		<li>{{ $t('bundle.sheets') }} {{ bundle.intSheets }}</li>
		<li>{{ $t('bundle.area') }} {{ bundle.decArea }} {{ $t('unit.sqm') }}</li>
	</ul>
</template>

<script>
	export default {
		name: "BundleInfo",
		props: ['bundle']
	}
</script>

<style lang="scss" scoped>
	ul {
		list-style: none;
		padding: 0;
		margin: 0;

		li {
			border-bottom: 1px solid #000000;

			&:last-child {
				border: none;
			}
		}
	}
</style>